function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var x = Object.defineProperty;
var V = function V(t, s, e) {
  return s in t ? x(t, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[s] = e;
};
var i = function i(t, s, e) {
  return V(t, _typeof(s) != "symbol" ? s + "" : s, e);
};
import { Controller as y } from "@hotwired/stimulus";
function n(_x, _x2) {
  return _n.apply(this, arguments);
}
function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(t, s) {
    var e,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            if (!s) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return T(t, e);
          case 4:
            _context.next = 8;
            break;
          case 6:
            _context.next = 8;
            return b(t, e);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _n.apply(this, arguments);
}
function T(_x3) {
  return _T.apply(this, arguments);
}
function _T() {
  _T = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(t) {
    var s,
      _C,
      e,
      a,
      o,
      r,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            s = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _C = C("Enter", t, s), e = _C.transitionClasses, a = _C.fromClasses, o = _C.toClasses, r = _C.toggleClass;
            return _context2.abrupt("return", v(t, {
              firstFrame: function firstFrame() {
                var _t$classList, _t$classList2, _t$classList3, _t$classList4;
                (_t$classList = t.classList).add.apply(_t$classList, _toConsumableArray(e.split(" "))), (_t$classList2 = t.classList).add.apply(_t$classList2, _toConsumableArray(a.split(" "))), (_t$classList3 = t.classList).remove.apply(_t$classList3, _toConsumableArray(o.split(" "))), (_t$classList4 = t.classList).remove.apply(_t$classList4, _toConsumableArray(r.split(" ")));
              },
              secondFrame: function secondFrame() {
                var _t$classList5, _t$classList6;
                (_t$classList5 = t.classList).remove.apply(_t$classList5, _toConsumableArray(a.split(" "))), (_t$classList6 = t.classList).add.apply(_t$classList6, _toConsumableArray(o.split(" ")));
              },
              ending: function ending() {
                var _t$classList7;
                (_t$classList7 = t.classList).remove.apply(_t$classList7, _toConsumableArray(e.split(" ")));
              }
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _T.apply(this, arguments);
}
function b(_x4) {
  return _b.apply(this, arguments);
}
function _b() {
  _b = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t) {
    var s,
      _C2,
      e,
      a,
      o,
      r,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            s = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _C2 = C("Leave", t, s), e = _C2.transitionClasses, a = _C2.fromClasses, o = _C2.toClasses, r = _C2.toggleClass;
            return _context3.abrupt("return", v(t, {
              firstFrame: function firstFrame() {
                var _t$classList8, _t$classList9, _t$classList10;
                (_t$classList8 = t.classList).add.apply(_t$classList8, _toConsumableArray(a.split(" "))), (_t$classList9 = t.classList).remove.apply(_t$classList9, _toConsumableArray(o.split(" "))), (_t$classList10 = t.classList).add.apply(_t$classList10, _toConsumableArray(e.split(" ")));
              },
              secondFrame: function secondFrame() {
                var _t$classList11, _t$classList12;
                (_t$classList11 = t.classList).remove.apply(_t$classList11, _toConsumableArray(a.split(" "))), (_t$classList12 = t.classList).add.apply(_t$classList12, _toConsumableArray(o.split(" ")));
              },
              ending: function ending() {
                var _t$classList13, _t$classList14;
                (_t$classList13 = t.classList).remove.apply(_t$classList13, _toConsumableArray(e.split(" "))), (_t$classList14 = t.classList).add.apply(_t$classList14, _toConsumableArray(r.split(" ")));
              }
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _b.apply(this, arguments);
}
function C(t, s, e) {
  return {
    transitionClasses: s.dataset["transition".concat(t)] || e[t.toLowerCase()] || t.toLowerCase(),
    fromClasses: s.dataset["transition".concat(t, "From")] || e["".concat(t.toLowerCase(), "From")] || "".concat(t.toLowerCase(), "-from"),
    toClasses: s.dataset["transition".concat(t, "To")] || e["".concat(t.toLowerCase(), "To")] || "".concat(t.toLowerCase(), "-to"),
    toggleClass: s.dataset.toggleClass || e.toggleClass || e.toggle || "hidden"
  };
}
function L(t) {
  t._stimulus_transition = {
    timeout: null,
    interrupted: !1
  };
}
function I(t) {
  t._stimulus_transition && t._stimulus_transition.interrupt && t._stimulus_transition.interrupt();
}
function v(t, s) {
  t._stimulus_transition && I(t);
  var e, a, o;
  return L(t), t._stimulus_transition.cleanup = function () {
    a || s.firstFrame(), o || s.secondFrame(), s.ending(), t._stimulus_transition = null;
  }, t._stimulus_transition.interrupt = function () {
    e = !0, t._stimulus_transition.timeout && clearTimeout(t._stimulus_transition.timeout), t._stimulus_transition.cleanup();
  }, new Promise(function (r) {
    e || requestAnimationFrame(function () {
      e || (s.firstFrame(), a = !0, requestAnimationFrame(function () {
        e || (s.secondFrame(), o = !0, t._stimulus_transition && (t._stimulus_transition.timeout = setTimeout(function () {
          if (e) {
            r();
            return;
          }
          t._stimulus_transition.cleanup(), r();
        }, w(t))));
      }));
    });
  });
}
function w(t) {
  var s = Number(getComputedStyle(t).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3,
    e = Number(getComputedStyle(t).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
  return s === 0 && (s = Number(getComputedStyle(t).animationDuration.replace("s", "")) * 1e3), s + e;
}
var g = /*#__PURE__*/function (_y) {
  _inherits(g, _y);
  var _super = _createSuper(g);
  function g() {
    _classCallCheck(this, g);
    return _super.apply(this, arguments);
  }
  _createClass(g, [{
    key: "connect",
    value: function connect() {
      var _this = this;
      setTimeout(function () {
        T(_this.element);
      }, this.showDelayValue), this.hasDismissAfterValue && setTimeout(function () {
        _this.close();
      }, this.dismissAfterValue);
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      b(this.element).then(function () {
        _this2.element.remove();
      });
    }
  }]);
  return g;
}(y);
i(g, "values", {
  dismissAfter: Number,
  showDelay: {
    type: Number,
    default: 0
  }
});
import { Controller as A } from "@hotwired/stimulus";
var h = /*#__PURE__*/function (_A) {
  _inherits(h, _A);
  var _super2 = _createSuper(h);
  function h() {
    _classCallCheck(this, h);
    return _super2.apply(this, arguments);
  }
  _createClass(h, [{
    key: "connect",
    value: function connect() {
      this.timeout = null;
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;
      clearTimeout(this.timeout), this.timeout = setTimeout(function () {
        _this3.statusTarget.textContent = _this3.submittingTextValue, _this3.formTarget.requestSubmit();
      }, this.submitDurationValue);
    }
  }, {
    key: "success",
    value: function success() {
      this.setStatus(this.successTextValue);
    }
  }, {
    key: "error",
    value: function error() {
      this.setStatus(this.errorTextValue);
    }
  }, {
    key: "setStatus",
    value: function setStatus(t) {
      var _this4 = this;
      this.statusTarget.textContent = t, this.timeout = setTimeout(function () {
        _this4.statusTarget.textContent = "";
      }, this.statusDurationValue);
    }
  }]);
  return h;
}(A);
i(h, "targets", ["form", "status"]), i(h, "values", {
  submitDuration: {
    type: Number,
    default: 1e3
  },
  statusDuration: {
    type: Number,
    default: 2e3
  },
  submittingText: {
    type: String,
    default: "Saving..."
  },
  successText: {
    type: String,
    default: "Saved!"
  },
  errorText: {
    type: String,
    default: "Unable to save."
  }
});
import { Controller as _ } from "@hotwired/stimulus";
var c = /*#__PURE__*/function (_ref) {
  _inherits(c, _ref);
  var _super3 = _createSuper(c);
  function c() {
    _classCallCheck(this, c);
    return _super3.apply(this, arguments);
  }
  _createClass(c, [{
    key: "update",
    value: function update() {
      this.preview = this.colorTarget.value;
    }
  }, {
    key: "preview",
    set: function set(t) {
      this.previewTarget.style[this.styleValue] = t;
      var s = this._getContrastYIQ(t);
      this.styleValue === "color" ? this.previewTarget.style.backgroundColor = s : this.previewTarget.style.color = s;
    }
  }, {
    key: "_getContrastYIQ",
    value: function _getContrastYIQ(t) {
      t = t.replace("#", "");
      var s = 128,
        e = parseInt(t.substr(0, 2), 16),
        a = parseInt(t.substr(2, 2), 16),
        o = parseInt(t.substr(4, 2), 16);
      return (e * 299 + a * 587 + o * 114) / 1e3 >= s ? "#000" : "#fff";
    }
  }]);
  return c;
}(_);
i(c, "targets", ["preview", "color"]), i(c, "values", {
  style: {
    type: String,
    default: "backgroundColor"
  }
});
import { Controller as D } from "@hotwired/stimulus";
var l = /*#__PURE__*/function (_D) {
  _inherits(l, _D);
  var _super4 = _createSuper(l);
  function l() {
    _classCallCheck(this, l);
    return _super4.apply(this, arguments);
  }
  _createClass(l, [{
    key: "connect",
    value: function connect() {
      this.boundBeforeCache = this.beforeCache.bind(this), document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "openValueChanged",
    value: function openValueChanged() {
      n(this.menuTarget, this.openValue, this.transitionOptions), this.openValue === !0 && this.hasMenuItemTarget && this.menuItemTargets[0].focus();
    }
  }, {
    key: "show",
    value: function show() {
      this.openValue = !0;
    }
  }, {
    key: "close",
    value: function close() {
      this.openValue = !1;
    }
  }, {
    key: "hide",
    value: function hide(t) {
      this.closeOnClickOutsideValue && t.target.nodeType && this.element.contains(t.target) === !1 && this.openValue && (this.openValue = !1), this.closeOnEscapeValue && t.key === "Escape" && this.openValue && (this.openValue = !1);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.openValue = !this.openValue;
    }
  }, {
    key: "nextItem",
    value: function nextItem(t) {
      t.preventDefault(), this.menuItemTargets[this.nextIndex].focus();
    }
  }, {
    key: "previousItem",
    value: function previousItem(t) {
      t.preventDefault(), this.menuItemTargets[this.previousIndex].focus();
    }
  }, {
    key: "currentItemIndex",
    get: function get() {
      return this.menuItemTargets.indexOf(document.activeElement);
    }
  }, {
    key: "nextIndex",
    get: function get() {
      return Math.min(this.currentItemIndex + 1, this.menuItemTargets.length - 1);
    }
  }, {
    key: "previousIndex",
    get: function get() {
      return Math.max(this.currentItemIndex - 1, 0);
    }
  }, {
    key: "transitionOptions",
    get: function get() {
      return {
        enter: this.hasEnterClass ? this.enterClasses.join(" ") : "transition ease-out duration-100",
        enterFrom: this.hasEnterFromClass ? this.enterFromClasses.join(" ") : "transform opacity-0 scale-95",
        enterTo: this.hasEnterToClass ? this.enterToClasses.join(" ") : "transform opacity-100 scale-100",
        leave: this.hasLeaveClass ? this.leaveClasses.join(" ") : "transition ease-in duration-75",
        leaveFrom: this.hasLeaveFromClass ? this.leaveFromClasses.join(" ") : "transform opacity-100 scale-100",
        leaveTo: this.hasLeaveToClass ? this.leaveToClasses.join(" ") : "transform opacity-0 scale-95",
        toggleClass: this.hasToggleClass ? this.toggleClasses.join(" ") : "hidden"
      };
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.openValue = !1, this.menuTarget.classList.add(this.transitionOptions.toggleClass);
    }
  }]);
  return l;
}(D);
i(l, "targets", ["menu", "button", "menuItem"]), i(l, "values", {
  open: {
    type: Boolean,
    default: !1
  },
  closeOnEscape: {
    type: Boolean,
    default: !0
  },
  closeOnClickOutside: {
    type: Boolean,
    default: !0
  }
}), i(l, "classes", ["enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo", "toggle"]);
import { Controller as F } from "@hotwired/stimulus";
var d = /*#__PURE__*/function (_F) {
  _inherits(d, _F);
  var _super5 = _createSuper(d);
  function d() {
    _classCallCheck(this, d);
    return _super5.apply(this, arguments);
  }
  _createClass(d, [{
    key: "connect",
    value: function connect() {
      this.openValue && this.open(), this.boundBeforeCache = this.beforeCache.bind(this), document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "open",
    value: function open() {
      this.dialogTarget.showModal();
    }
  }, {
    key: "close",
    value: function close() {
      var _this5 = this;
      this.dialogTarget.setAttribute("closing", ""), Promise.all(this.dialogTarget.getAnimations().map(function (t) {
        return t.finished;
      })).then(function () {
        _this5.dialogTarget.removeAttribute("closing"), _this5.dialogTarget.close();
      });
    }
  }, {
    key: "backdropClose",
    value: function backdropClose(t) {
      t.target.nodeName == "DIALOG" && this.close();
    }
  }, {
    key: "show",
    value: function show() {
      this.dialogTarget.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.close();
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.close();
    }
  }]);
  return d;
}(F);
i(d, "targets", ["dialog"]), i(d, "values", {
  open: Boolean
});
import { Controller as B } from "@hotwired/stimulus";
var f = /*#__PURE__*/function (_B) {
  _inherits(f, _B);
  var _super6 = _createSuper(f);
  function f() {
    _classCallCheck(this, f);
    return _super6.apply(this, arguments);
  }
  _createClass(f, [{
    key: "openValueChanged",
    value: function openValueChanged() {
      n(this.contentTarget, this.openValue), this.shouldAutoDismiss && this.scheduleDismissal();
    }
  }, {
    key: "show",
    value: function show(t) {
      this.shouldAutoDismiss && this.scheduleDismissal(), this.openValue = !0;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.openValue = !1;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.openValue = !this.openValue;
    }
  }, {
    key: "shouldAutoDismiss",
    get: function get() {
      return this.openValue && this.hasDismissAfterValue;
    }
  }, {
    key: "scheduleDismissal",
    value: function scheduleDismissal() {
      var _this6 = this;
      this.hasDismissAfterValue && (this.cancelDismissal(), this.timeoutId = setTimeout(function () {
        _this6.hide(), _this6.timeoutId = void 0;
      }, this.dismissAfterValue));
    }
  }, {
    key: "cancelDismissal",
    value: function cancelDismissal() {
      typeof this.timeoutId == "number" && (clearTimeout(this.timeoutId), this.timeoutId = void 0);
    }
  }]);
  return f;
}(B);
i(f, "targets", ["content"]), i(f, "values", {
  dismissAfter: Number,
  open: {
    type: Boolean,
    default: !1
  }
});
import { Controller as E } from "@hotwired/stimulus";
var m = /*#__PURE__*/function (_E) {
  _inherits(m, _E);
  var _super7 = _createSuper(m);
  function m() {
    _classCallCheck(this, m);
    return _super7.apply(this, arguments);
  }
  _createClass(m, [{
    key: "connect",
    value: function connect() {
      this.openValue && this.open(), this.boundBeforeCache = this.beforeCache, document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "open",
    value: function open() {
      this.dialogTarget.showModal();
    }
  }, {
    key: "close",
    value: function close() {
      var _this7 = this;
      this.dialogTarget.setAttribute("closing", ""), Promise.all(this.dialogTarget.getAnimations().map(function (t) {
        return t.finished;
      })).then(function () {
        _this7.dialogTarget.removeAttribute("closing"), _this7.dialogTarget.close();
      });
    }
  }, {
    key: "backdropClose",
    value: function backdropClose(t) {
      t.target.nodeName == "DIALOG" && this.close();
    }
  }, {
    key: "show",
    value: function show() {
      this.open();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.close();
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.close();
    }
  }]);
  return m;
}(E);
i(m, "targets", ["dialog"]), i(m, "values", {
  open: Boolean
});
import { Controller as S } from "@hotwired/stimulus";
var u = /*#__PURE__*/function (_S) {
  _inherits(u, _S);
  var _super8 = _createSuper(u);
  function u() {
    _classCallCheck(this, u);
    return _super8.apply(this, arguments);
  }
  _createClass(u, [{
    key: "initialize",
    value: function initialize() {
      var _this8 = this;
      this.updateAnchorValue && this.anchor && (this.indexValue = this.tabTargets.findIndex(function (t) {
        return t.id === _this8.anchor;
      }));
    }
  }, {
    key: "connect",
    value: function connect() {
      this.showTab();
    }
  }, {
    key: "change",
    value: function change(t) {
      t.currentTarget.tagName === "SELECT" ? this.indexValue = t.currentTarget.selectedIndex : t.currentTarget.dataset.index ? this.indexValue = t.currentTarget.dataset.index : t.currentTarget.dataset.id ? this.indexValue = this.tabTargets.findIndex(function (s) {
        return s.id == t.currentTarget.dataset.id;
      }) : this.indexValue = this.tabTargets.indexOf(t.currentTarget);
    }
  }, {
    key: "nextTab",
    value: function nextTab() {
      this.indexValue = Math.min(this.indexValue + 1, this.tabsCount - 1);
    }
  }, {
    key: "previousTab",
    value: function previousTab() {
      this.indexValue = Math.max(this.indexValue - 1, 0);
    }
  }, {
    key: "firstTab",
    value: function firstTab() {
      this.indexValue = 0;
    }
  }, {
    key: "lastTab",
    value: function lastTab() {
      this.indexValue = this.tabsCount - 1;
    }
  }, {
    key: "indexValueChanged",
    value: function indexValueChanged() {
      if (this.showTab(), this.dispatch("tab-change", {
        target: this.tabTargets[this.indexValue],
        detail: {
          activeIndex: this.indexValue
        }
      }), this.updateAnchorValue) {
        var t = this.tabTargets[this.indexValue].id;
        if (this.scrollToAnchorValue) location.hash = t;else {
          var e = window.location.href.split("#")[0] + "#" + t;
          (typeof Turbo === "undefined" ? "undefined" : _typeof(Turbo)) < "u" ? Turbo.navigator.history.replace(new URL(e)) : history.replaceState({}, document.title, e);
        }
      }
    }
  }, {
    key: "showTab",
    value: function showTab() {
      var _this9 = this;
      this.panelTargets.forEach(function (t, s) {
        var _e$classList, _e$classList2, _e$classList3, _e$classList4;
        var e = _this9.tabTargets[s];
        s === _this9.indexValue ? (t.classList.remove("hidden"), e.ariaSelected = "true", e.dataset.active = !0, _this9.hasInactiveTabClass && e !== null && e !== void 0 && (_e$classList = e.classList) !== null && _e$classList !== void 0 && _e$classList.remove.apply(_e$classList, _toConsumableArray(_this9.inactiveTabClasses)), _this9.hasActiveTabClass && (e === null || e === void 0 ? void 0 : (_e$classList2 = e.classList) === null || _e$classList2 === void 0 ? void 0 : _e$classList2.add.apply(_e$classList2, _toConsumableArray(_this9.activeTabClasses)))) : (t.classList.add("hidden"), e.ariaSelected = null, delete e.dataset.active, _this9.hasActiveTabClass && e !== null && e !== void 0 && (_e$classList3 = e.classList) !== null && _e$classList3 !== void 0 && _e$classList3.remove.apply(_e$classList3, _toConsumableArray(_this9.activeTabClasses)), _this9.hasInactiveTabClass && (e === null || e === void 0 ? void 0 : (_e$classList4 = e.classList) === null || _e$classList4 === void 0 ? void 0 : _e$classList4.add.apply(_e$classList4, _toConsumableArray(_this9.inactiveTabClasses))));
      }), this.hasSelectTarget && (this.selectTarget.selectedIndex = this.indexValue), this.scrollActiveTabIntoViewValue && this.scrollToActiveTab();
    }
  }, {
    key: "scrollToActiveTab",
    value: function scrollToActiveTab() {
      var t = this.element.querySelector("[aria-selected]");
      t && t.scrollIntoView({
        inline: "center"
      });
    }
  }, {
    key: "tabsCount",
    get: function get() {
      return this.tabTargets.length;
    }
  }, {
    key: "anchor",
    get: function get() {
      return document.URL.split("#").length > 1 ? document.URL.split("#")[1] : null;
    }
  }]);
  return u;
}(S);
i(u, "classes", ["activeTab", "inactiveTab"]), i(u, "targets", ["tab", "panel", "select"]), i(u, "values", {
  index: 0,
  updateAnchor: Boolean,
  scrollToAnchor: Boolean,
  scrollActiveTabIntoView: Boolean
});
import { Controller as N } from "@hotwired/stimulus";
var p = /*#__PURE__*/function (_N) {
  _inherits(p, _N);
  var _super9 = _createSuper(p);
  function p() {
    _classCallCheck(this, p);
    return _super9.apply(this, arguments);
  }
  _createClass(p, [{
    key: "toggle",
    value: function toggle(t) {
      this.openValue = !this.openValue, this.animate();
    }
  }, {
    key: "toggleInput",
    value: function toggleInput(t) {
      this.openValue = t.target.checked, this.animate();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.openValue = !1, this.animate();
    }
  }, {
    key: "show",
    value: function show() {
      this.openValue = !0, this.animate();
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this10 = this;
      this.toggleableTargets.forEach(function (t) {
        n(t, _this10.openValue);
      });
    }
  }]);
  return p;
}(N);
i(p, "targets", ["toggleable"]), i(p, "values", {
  open: {
    type: Boolean,
    default: !1
  }
});
export { g as Alert, h as Autosave, c as ColorPreview, l as Dropdown, d as Modal, f as Popover, m as Slideover, u as Tabs, p as Toggle, n as transition };